/**
 * Generated from LightsOutIntroLayout.fla
 */
export function LightsOutIntroLayout(this: ILightsOutIntroLayout) {
	const bg = this.bg;
	LightsOutIntroLayout_bg.call(this.bg);
	bg.x = 512;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	if (bg.onLayout) bg.onLayout();
	const elmo = this.elmo;
	LightsOutIntroLayout_elmo.call(this.elmo);
	elmo.x = 642.25;
	elmo.y = 659;
	elmo.width = 221.00;
	elmo.height = 320.00;
	if (elmo.onLayout) elmo.onLayout();
	const skipButton = this.skipButton;
	LightsOutIntroLayout_skipButton.call(this.skipButton);
	skipButton.x = 946.25;
	skipButton.y = 687.75;
	skipButton.width = 156.50;
	skipButton.height = 161.50;
	if (skipButton.onLayout) skipButton.onLayout();
	const homeButton = this.homeButton;
	LightsOutIntroLayout_homeButton.call(this.homeButton);
	homeButton.x = 108;
	homeButton.y = 164.5;
	homeButton.width = 146.00;
	homeButton.height = 151.00;
	if (homeButton.onLayout) homeButton.onLayout();
	const grover = this.grover;
	LightsOutIntroLayout_grover.call(this.grover);
	grover.x = 408.75;
	grover.y = 654;
	grover.width = 279.00;
	grover.height = 426.00;
	if (grover.onLayout) grover.onLayout();
	return this;
}
function LightsOutIntroLayout_bg(this: ILightsOutIntroLayout_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("background-lights-out-intro.png", 0.500, 0.500);
	return this;
}
function LightsOutIntroLayout_elmo(this: ILightsOutIntroLayout_elmo) {
	if (this.setLayoutTexture) this.setLayoutTexture("Elmo.png", 0.500, 1.000);
	return this;
}
function LightsOutIntroLayout_skipButton(this: ILightsOutIntroLayout_skipButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("skip-btn.png", 0.500, 0.500);
	return this;
}
function LightsOutIntroLayout_homeButton(this: ILightsOutIntroLayout_homeButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("home-btn.png", 0.500, 0.500);
	return this;
}
function LightsOutIntroLayout_grover(this: ILightsOutIntroLayout_grover) {
	if (this.setLayoutTexture) this.setLayoutTexture("Grover-wave-2.png", 0.588, 0.981);
	return this;
}
interface ILightsOutIntroLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface ILightsOutIntroLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface ILightsOutIntroLayoutSprite extends ILightsOutIntroLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface ILightsOutIntroLayoutText extends ILightsOutIntroLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface ILightsOutIntroLayoutPolygon extends Array<number> {
}
interface ILightsOutIntroLayout {
	readonly bg: ILightsOutIntroLayout_bg;
	readonly elmo: ILightsOutIntroLayout_elmo;
	readonly skipButton: ILightsOutIntroLayout_skipButton;
	readonly homeButton: ILightsOutIntroLayout_homeButton;
	readonly grover: ILightsOutIntroLayout_grover;
}
interface ILightsOutIntroLayout_bg extends ILightsOutIntroLayoutSprite {
}
interface ILightsOutIntroLayout_elmo extends ILightsOutIntroLayoutSprite {
}
interface ILightsOutIntroLayout_skipButton extends ILightsOutIntroLayoutSprite {
}
interface ILightsOutIntroLayout_homeButton extends ILightsOutIntroLayoutSprite {
}
interface ILightsOutIntroLayout_grover extends ILightsOutIntroLayoutSprite {
}
